import { GalleryContext, GalleryNavigationContext } from "./chunk-JMBPVZMW.js";
import { Figure_default } from "./chunk-AN4JJSLI.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Gallery/Gallery.Navigation.Item.tsx
import { useMemo, useContext, useCallback } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var GalleryNavigationItem = _a => {
  var _b = _a,
    {
      children,
      itemNumber,
      onClick,
      className
    } = _b,
    rest = __objRest(_b, ["children", "itemNumber", "onClick", "className"]);
  const {
    id,
    activeItem,
    setActiveItem
  } = useContext(GalleryContext);
  const {
    isNavExpanded,
    isNavExpandable,
    maxItems
  } = useContext(GalleryNavigationContext);
  const handleClick = useCallback(event => {
    setActiveItem(itemNumber);
    onClick == null ? void 0 : onClick(event);
  }, [onClick, setActiveItem, itemNumber]);
  const isActive = useMemo(() => {
    if (itemNumber === void 0) {
      return false;
    }
    if (itemNumber === activeItem) {
      return true;
    }
    if (activeItem > maxItems && itemNumber > maxItems && !isNavExpanded && isNavExpandable) {
      return true;
    }
    return false;
  }, [itemNumber, activeItem, maxItems, isNavExpanded, isNavExpandable]);
  return /* @__PURE__ */jsx("li", {
    className: "pd:gallery-navigation__item",
    role: "tab",
    "aria-selected": isActive ? "true" : "false",
    children: /* @__PURE__ */jsxs(Figure_default, __spreadProps(__spreadValues({}, rest), {
      as: "button",
      type: "button",
      onClick: handleClick,
      "aria-controls": "".concat(id, "-item-").concat(itemNumber),
      className: clsx("pd:gallery-navigation__button", isActive && "pd:gallery-navigation__button--active", className),
      children: [/* @__PURE__ */jsx("span", {
        className: "pd:sr-only",
        children: itemNumber
      }), children]
    }))
  });
};
var Gallery_Navigation_Item_default = GalleryNavigationItem;
export { Gallery_Navigation_Item_default };